(function () {
  var SHEET_MQ = '(max-width: 1023.98px)';

  function HeroCustomSelect(root) {
    this.root = root;
    this.enableSearch = root.dataset.search === 'true';
    this.hiddenSelect = root.querySelector('.asf-brand-select__native');
    this.trigger = root.querySelector('[data-select-trigger]');
    this.triggerLabel = root.querySelector('[data-select-label]');
    this.panel = root.querySelector('[data-select-panel]');
    this.backdrop = root.querySelector('[data-select-backdrop]');
    this.closeBtn = root.querySelector('[data-select-close]');
    this.searchInput = root.querySelector('[data-select-search]');
    this.list = root.querySelector('[data-select-list]');
    this.allOptions = [];
    this.isOpen = false;
    this.mediaQuery = window.matchMedia(SHEET_MQ);

    this.readOptionsFromSelect();
    this.bindEvents();
    this.updateTriggerLabel(this.hiddenSelect.value);
    this.renderList('');
  }

  HeroCustomSelect.prototype.isSheetMode = function () {
    return this.mediaQuery.matches;
  };

  HeroCustomSelect.prototype.readOptionsFromSelect = function () {
    this.allOptions = Array.from(this.hiddenSelect.options)
      .filter(function (opt) {
        return opt.style.display !== 'none' && opt.getAttribute('aria-hidden') !== 'true';
      })
      .map(function (opt) {
        return { value: opt.value, text: opt.text };
      });
  };

  HeroCustomSelect.prototype.setOptions = function (options) {
    this.allOptions = options.slice();
    this.hiddenSelect.innerHTML = '';

    var index = 0;
    while (index < options.length) {
      var opt = options[index];
      var el = document.createElement('option');
      el.value = opt.value;
      el.textContent = opt.text;
      this.hiddenSelect.appendChild(el);
      index += 1;
    }

    this.hiddenSelect.value = '';
    this.updateTriggerLabel('');
    this.renderList(this.enableSearch && this.searchInput ? this.searchInput.value : '');
  };

  HeroCustomSelect.prototype.getDefaultLabel = function () {
    return this.allOptions.length ? this.allOptions[0].text : '';
  };

  HeroCustomSelect.prototype.updateTriggerLabel = function (value) {
    if (!value) {
      this.triggerLabel.textContent = this.getDefaultLabel();
      return;
    }

    var match = null;
    var index = 0;
    while (index < this.allOptions.length) {
      if (this.allOptions[index].value === value) {
        match = this.allOptions[index];
        break;
      }
      index += 1;
    }

    this.triggerLabel.textContent = match ? match.text : this.getDefaultLabel();
  };

  HeroCustomSelect.prototype.getSelectableOptions = function () {
    return this.allOptions.filter(function (opt) {
      return opt.value !== '';
    });
  };

  HeroCustomSelect.prototype.filterOptions = function (query) {
    var normalized = String(query || '').trim().toLowerCase();
    var options = this.getSelectableOptions();

    if (!normalized || !this.enableSearch) return options;

    return options.filter(function (opt) {
      return opt.text.toLowerCase().indexOf(normalized) !== -1;
    });
  };

  HeroCustomSelect.prototype.renderList = function (query) {
    var normalized = String(query || '').trim().toLowerCase();
    var defaultOption = this.allOptions[0];
    var filtered = this.filterOptions(query);
    var hasDefault = defaultOption
      && (!normalized || !this.enableSearch || defaultOption.text.toLowerCase().indexOf(normalized) !== -1);

    this.list.innerHTML = '';

    var self = this;

    function appendOption(opt) {
      var item = document.createElement('li');
      item.className = 'asf-brand-select__option';
      item.setAttribute('role', 'option');
      item.setAttribute('data-value', opt.value);
      item.textContent = opt.text;

      if (self.hiddenSelect.value === opt.value) {
        item.setAttribute('aria-selected', 'true');
        item.classList.add('is-selected');
      }

      item.addEventListener('click', function () {
        self.selectValue(opt.value);
      });

      self.list.appendChild(item);
    }

    if (hasDefault) {
      appendOption(defaultOption);
    }

    var index = 0;
    while (index < filtered.length) {
      appendOption(filtered[index]);
      index += 1;
    }

    if (!hasDefault && !filtered.length) {
      var empty = document.createElement('li');
      empty.className = 'asf-brand-select__empty';
      empty.textContent = 'No results found';
      this.list.appendChild(empty);
    }
  };

  HeroCustomSelect.prototype.selectValue = function (value) {
    this.hiddenSelect.value = value;
    this.hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
    this.updateTriggerLabel(value);
    this.renderList(this.enableSearch && this.searchInput ? this.searchInput.value : '');
    this.close();
  };

  HeroCustomSelect.prototype.closeOtherDropdowns = function () {
    var openDropdowns = document.querySelectorAll('.asf-brand-select.is-open');
    var index = 0;

    while (index < openDropdowns.length) {
      var dropdown = openDropdowns[index];
      if (dropdown !== this.root && dropdown._heroCustomSelect) {
        dropdown._heroCustomSelect.close(true);
      }
      index += 1;
    }
  };

  HeroCustomSelect.prototype.mountSheetToBody = function () {
    if (this.sheetMounted || !this.backdrop) return;

    document.body.appendChild(this.backdrop);
    document.body.appendChild(this.panel);
    this.sheetMounted = true;
  };

  HeroCustomSelect.prototype.unmountSheetFromBody = function () {
    if (!this.sheetMounted) return;

    this.root.appendChild(this.backdrop);
    this.root.appendChild(this.panel);
    this.sheetMounted = false;
  };

  HeroCustomSelect.prototype.syncBodyLock = function () {
    var openSheet = document.querySelector('.asf-brand-select.is-sheet.is-open, .asf-brand-select__panel.is-open');
    document.body.classList.toggle('asf-sheet-open', !!openSheet);
  };

  HeroCustomSelect.prototype.setSheetOpenClass = function (isOpen) {
    this.root.classList.toggle('is-open', isOpen);
    this.panel.classList.toggle('is-open', isOpen);

    if (this.backdrop) {
      this.backdrop.classList.toggle('is-open', isOpen);
    }
  };

  HeroCustomSelect.prototype.setDropdownOpenState = function () {
    var slideShow = this.root.closest('slide-show');
    var section = this.root.closest('.slideshow-section');
    var hasDesktopOpen = document.querySelector('.asf-brand-select.is-open:not(.is-sheet)') !== null;

    if (slideShow) {
      slideShow.classList.toggle('asf-dropdown-open', hasDesktopOpen);
    }

    if (section) {
      section.classList.toggle('asf-dropdown-open', hasDesktopOpen);
    }

    this.syncBodyLock();
  };

  HeroCustomSelect.prototype.setFieldOpenState = function (isOpen) {
    var field = this.root.closest('.asf-field');
    if (!field) return;

    field.classList.toggle('asf-field--dropdown-open', isOpen);
  };

  HeroCustomSelect.prototype.clearCloseTimer = function () {
    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    if (this.onPanelTransitionEnd) {
      this.panel.removeEventListener('transitionend', this.onPanelTransitionEnd);
      this.onPanelTransitionEnd = null;
    }
  };

  HeroCustomSelect.prototype.finishClose = function () {
    this.clearCloseTimer();
    this.isOpen = false;
    this.setSheetOpenClass(false);
    this.panel.hidden = true;

    if (this.backdrop) {
      this.backdrop.hidden = true;
    }

    this.unmountSheetFromBody();
    this.trigger.setAttribute('aria-expanded', 'false');
    this.root.classList.remove('is-sheet');
    this.setFieldOpenState(false);
    this.setDropdownOpenState();

    if (this.enableSearch && this.searchInput) {
      this.searchInput.value = '';
    }

    this.renderList('');
  };

  HeroCustomSelect.prototype.open = function () {
    if (this.isOpen) return;

    this.closeOtherDropdowns();
    this.clearCloseTimer();
    this.isOpen = true;
    this.panel.hidden = false;

    if (this.backdrop) {
      this.backdrop.hidden = !this.isSheetMode();
    }

    this.trigger.setAttribute('aria-expanded', 'true');
    this.root.classList.toggle('is-sheet', this.isSheetMode());
    this.setFieldOpenState(!this.isSheetMode());
    this.renderList('');

    if (this.enableSearch && this.searchInput) {
      this.searchInput.value = '';
    }

    if (this.isSheetMode()) {
      var self = this;
      this.mountSheetToBody();
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (!self.isOpen) return;
          self.setSheetOpenClass(true);
          self.setDropdownOpenState();
        });
      });
      return;
    }

    this.setSheetOpenClass(true);
    this.setDropdownOpenState();
    this.trigger.focus();
  };

  HeroCustomSelect.prototype.close = function (immediate) {
    if (!this.isOpen && !this.root.classList.contains('is-open') && !this.panel.classList.contains('is-open')) return;

    this.isOpen = false;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.setFieldOpenState(false);

    if (this.enableSearch && this.searchInput) {
      this.searchInput.value = '';
    }

    if (this.isSheetMode() && !immediate && this.panel.classList.contains('is-open')) {
      var self = this;

      this.setSheetOpenClass(false);
      this.setDropdownOpenState();

      this.onPanelTransitionEnd = function (evt) {
        if (evt.target !== self.panel || evt.propertyName !== 'transform') return;
        self.finishClose();
      };

      this.panel.addEventListener('transitionend', this.onPanelTransitionEnd);
      this.closeTimer = window.setTimeout(function () {
        self.finishClose();
      }, 400);
      return;
    }

    this.finishClose();
  };

  HeroCustomSelect.prototype.toggle = function () {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  };

  HeroCustomSelect.prototype.bindEvents = function () {
    var self = this;

    this.trigger.addEventListener('click', function () {
      self.toggle();
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function () {
        self.close();
        self.trigger.focus();
      });
    }

    if (this.backdrop) {
      this.backdrop.addEventListener('click', function () {
        self.close();
      });
    }

    if (this.enableSearch && this.searchInput) {
      this.searchInput.addEventListener('input', function () {
        self.renderList(self.searchInput.value);
      });

      this.searchInput.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter') {
          evt.preventDefault();
        }

        if (evt.key === 'Escape') {
          evt.preventDefault();
          self.close();
          self.trigger.focus();
        }
      });
    }

    document.addEventListener('click', function (evt) {
      if (!self.isOpen || self.isSheetMode()) return;
      if (!self.root.contains(evt.target)) self.close();
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && self.isOpen) {
        self.close();
        self.trigger.focus();
      }
    });

    var onBreakpointChange = function () {
      if (!self.isOpen) return;

      if (self.isSheetMode()) {
        self.root.classList.add('is-sheet');
        if (self.backdrop) self.backdrop.hidden = false;
        self.mountSheetToBody();
        self.setSheetOpenClass(true);
        self.setFieldOpenState(false);
      } else {
        self.setSheetOpenClass(true);
        self.unmountSheetFromBody();
        self.root.classList.remove('is-sheet');
        if (self.backdrop) {
          self.backdrop.hidden = true;
          self.backdrop.classList.remove('is-open');
        }
        self.setFieldOpenState(true);
      }

      self.setDropdownOpenState();
    };

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', onBreakpointChange);
    } else if (this.mediaQuery.addListener) {
      this.mediaQuery.addListener(onBreakpointChange);
    }
  };

  window.initHeroCustomSelect = function initHeroCustomSelect(root) {
    if (!root || root.dataset.heroCustomSelectInit === 'true') return null;

    root.dataset.heroCustomSelectInit = 'true';
    var instance = new HeroCustomSelect(root);
    root._heroCustomSelect = instance;
    return instance;
  };

  window.initHeroBrandSelect = window.initHeroCustomSelect;
})();
